const disableResizeTransform = () => {
  const navClasslist = document.querySelector(".wp-block-navigation__responsive-container-content")?.classList;
  if (!navClasslist) return;
  let resizeTimer;
  window.addEventListener("resize", () => {
    navClasslist.add("no-transition");
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => navClasslist.remove("no-transition"), 250);
  });
};

const megaMenu = () => {
  const megaMenuButtons = document.querySelectorAll(".has-wlc-mega-menu");
  const wpAdminBar = document.querySelector("#wpadminbar");
  const header = document.querySelector(".header");

  if (!megaMenuButtons.length || !header) return;

  megaMenuButtons.forEach((button) => {
    let isOpen = false;
    const megaMenu = button.querySelector(".wlc-mega-menu");
    const closeMobile = button.querySelector(".close-mobile");

    if (!megaMenu || !closeMobile) return;

    closeMobile.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      button.classList.remove("wlc-mega-menu--open");
      isOpen = false;
      window.removeEventListener("resize", resizeHandler);
    });

    const resizeHandler = () => {
      if (isOpen) {
        megaMenu.style.width = window.innerWidth - 16 + "px";
      } else {
        window.removeEventListener("resize", resizeHandler);
      }
    };

    button.addEventListener("click", (e) => {
      const target = e.target;
      if (!target.classList.contains("wp-block-navigation-item__label")) {
        return;
      }

      const currentWidth = window.innerWidth;

      if (isOpen) {
        button.classList.remove("wlc-mega-menu--open");
        isOpen = false;

        // Remove the resize event listener when the menu is closed.
        window.removeEventListener("resize", resizeHandler);
        return;
      }

      isOpen = true;

      megaMenu.style.width = currentWidth - 16 + "px";

      // Add the resize event listener when the menu is open.
      window.addEventListener("resize", resizeHandler);

      window.addEventListener("click", (e) => {
        if (e.target.closest(".has-wlc-mega-menu") !== button) {
          button.classList.remove("wlc-mega-menu--open");
          isOpen = false;
          window.removeEventListener("resize", resizeHandler);
        }
      });
    });
  });
};

const menuToggle = () => {
  const menuWrapper = document.querySelector(".header-wrapper");
  const menu = document.querySelector(".main-menu-wrapper");

  const toggleButton = document.createElement("button");
  toggleButton.classList.add("menu-toggle");

  toggleButton.addEventListener("click", () => {
    toggleButton.classList.toggle("open");
    menu.classList.toggle("open");
  });

  menuWrapper.appendChild(toggleButton);
};

const megaMenuOnHover = () => {
  if (window.innerWidth < 1200) return;

  const megaMenuItems = document.querySelectorAll(".has-wlc-mega-menu");

  if (!megaMenuItems.length) return;

  megaMenuItems.forEach((item) => {
    const megaMenu = item.querySelector(".wlc-mega-menu");

    let timer;

    const openMenu = () => {
      clearTimeout(timer);
      const currentWidth = window.innerWidth;
      item.classList.add("wlc-mega-menu--open");
      megaMenu.style.width = currentWidth - 16 + "px";
    };

    const closeMenu = () => {
      timer = setTimeout(() => {
        item.classList.remove("wlc-mega-menu--open");
      }, 200);
    };

    item.addEventListener("mouseenter", openMenu);
    item.addEventListener("mouseleave", closeMenu);

    megaMenu.addEventListener("mouseenter", openMenu);
    megaMenu.addEventListener("mouseleave", closeMenu);
  });
};

export { disableResizeTransform, megaMenu, menuToggle, megaMenuOnHover };
